import React, { useContext,useEffect,useState } from 'react';
import { FormContext } from '../../context/form/FormContext';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import QuestionName from '../styleComponents/QuestionName';
import doubleLineIcon from '../../assets/svg/double-line.svg'
import arrowUpIcon from '../../assets/svg/arrow-up.svg'
import arrowDownIcon from '../../assets/svg/arrow-down.svg'

const Ranking = ({ id, question, qDescription, answersM = [], answersR = []}) => {
    const { handleChange } = useContext(FormContext)
    const [characters, setCharacters] = useState([]);

    useEffect(()=>{
      if (answersR.length > 0) setCharacters(answersR)
      else setCharacters(answersM.map((option, index) => ({option, index})))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(()=>{
      handleChange(id, characters)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [characters])


  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = [...characters]
     const [reorderedItem] = items.splice(result.source.index, 1);
     items.splice(result.destination.index, 0, reorderedItem);
     items.forEach(function(item, index) {
      item.index = index
    }); 
     setCharacters(items)
  }

  const handleCharactersPosition = (index, isUp) =>{
    const newCharacters = [...characters]
    const before = newCharacters[index]
    if (!isUp) {
      const after = newCharacters[index + 1]
      newCharacters.splice(index, 1, after)
      newCharacters.splice(index + 1, 1, before)
      newCharacters.forEach(function(item, index) {
        item.index = index
      }); 
      setCharacters(newCharacters)
      return
    }
    const after = newCharacters[index - 1]
    newCharacters.splice(index, 1, after)
    newCharacters.splice(index - 1, 1, before)
    newCharacters.forEach(function(item, index) {
      item.index = index
    });
    setCharacters(newCharacters)
  }
  
    return (
      <>
        <QuestionName questionName={question} description={qDescription}/>
        <div className="mb-3">
            <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId={`${id}-${question}`}>
            {(provided) => (
              <ul className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                {characters.map(({option}, index) => {
                  return (
                    <Draggable key={`${option}-${question}`} draggableId={`${option}-${question}`} index={index}>
                      {(provided) => (
                        <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>  
                          <div key={`${option}-${question}`} className='characters__container'> 
                            <div className='character__option'><img src={doubleLineIcon} alt='icon' width={20}/> <span className='text-white'>{ option }</span> </div>
                            <div className='characters__buttons'>
                              <button type='button' disabled={index === 0} onClick={() => handleCharactersPosition(index, true)}>
                                <img src={arrowUpIcon} alt='icon'/>
                              </button>
                              <button type='button' disabled={index === characters.length -1} onClick={() =>handleCharactersPosition(index, false)}>
                               <img src={arrowDownIcon} alt='icon'/>
                              </button>
                            </div>
                          </div>
                        </li>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
        </div>
      </>  
    )
}

export default Ranking
